import { render, staticRenderFns } from "./BurnDeviceList.vue?vue&type=template&id=f7594fda&scoped=true&"
import script from "./BurnDeviceList.vue?vue&type=script&lang=ts&"
export * from "./BurnDeviceList.vue?vue&type=script&lang=ts&"
import style0 from "./BurnDeviceList.vue?vue&type=style&index=0&id=f7594fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7594fda",
  null
  
)

export default component.exports